import { render, staticRenderFns } from "./GestionePeriodi.vue?vue&type=template&id=09cae34c&scoped=true&"
import script from "./GestionePeriodi.vue?vue&type=script&lang=ts&"
export * from "./GestionePeriodi.vue?vue&type=script&lang=ts&"
import style0 from "./GestionePeriodi.vue?vue&type=style&index=0&id=09cae34c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cae34c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VCol,VRow,VSwitch})
